// extracted by mini-css-extract-plugin
export default {"advertDetailContactItem":"c-l_gJ","advertDetailContactItem__link":"c-l_gK","advertDetailContactItem__stub":"c-l_gL"};